import { ActivityDetailsByActionType } from 'modules/campaigns/modules/campaigns-reports/config/reports/performance-rule-executed-actions/ActivityDetailsByActionType';

const messageConfig = ({ actionType, additionalData }) => {
    const changeType = additionalData?.budgetAdditionalData?.changeType;
    const messageId = changeType
        ? `performance.rule.executed.actions.report.actionType.details.${actionType}.${changeType}`
        : `performance.rule.executed.actions.report.actionType.details.${actionType}`;

    return ActivityDetailsByActionType[messageId];
};

export const ActivityDetailsValueGetter = ({ rowData, i18n }) => {
    const {
        affectedEntity: { id, name },
        actionType,
        additionalData,
    } = rowData;
    const { changeValue, changeType } = additionalData?.budgetAdditionalData || {};
    const msgConfig = messageConfig({ actionType, additionalData });
    const formattedMessage = i18n.formatMessage(
        {
            ...msgConfig,
        },
        {
            name,
            id,
            changeValue,
            changeType,
            currency: '$',
        }
    );
    return `${formattedMessage}`;
};
